import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import DeleteIcon from "@material-ui/icons/Delete";

import ConfirmationButton from "./confirmation_button";

const useStyles = makeStyles((theme) => ({
  table: {
    minWidth: 650,
  },
  button: {
    margin: 0,
    color: theme.palette.common.white,
    textTransform: "capitalize",
  },
}));

function TableLinkButton(props, classes, rowIndex, cell) {
  return (
    <a href={props.tableUrls[rowIndex]}>
      <Button
        variant="contained"
        color="primary"
        className={classes.button}
        startIcon={props.linkIcon}
      >
        {cell}
      </Button>
    </a>
  );
}

export default function DefaultTable(props) {
  const classes = useStyles();

  return (
    <TableContainer key={props.tableKey} component={Paper} elevation={4}>
      <Table className={classes.table} aria-label="simple table">
        <TableHead>
          <TableRow>
            {props.tableHeaders.map((header) => (
              <TableCell key={"header-" + header}>
                <b>{header}</b>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {props.tableRows.map((row, rowIndex) => (
            <TableRow key={props.tableKey + "-row-" + rowIndex}>
              {row.map((cell, cellIndex) =>
                props.tableRows &&
                cellIndex === 0 &&
                props.tableUrls &&
                props.tableUrls[rowIndex] != null ? (
                  <TableCell key={props.tableKey + "-cell-" + cellIndex}>
                    {TableLinkButton(props, classes, rowIndex, cell)}
                  </TableCell>
                ) : cell && cell.constructor.name === "Array" ? (
                  <TableCell key={props.tableKey + "-cell-" + cellIndex}>
                    {cell.map((item, itemIndex) => (
                      <p
                        key={
                          props.tableKey +
                          "-cell-" +
                          cellIndex +
                          "-item-" +
                          itemIndex
                        }
                      >
                        {item}
                      </p>
                    ))}
                  </TableCell>
                ) : (
                  <TableCell key={props.tableKey + "-cell-" + cellIndex}>
                    {cell}
                  </TableCell>
                )
              )}
              {props.deletable ? (
                <TableCell>
                  <ConfirmationButton
                    onClick={() => props.onRowDelete(rowIndex)}
                    title="Delete Row"
                    confirmationMessage="Confirming will delete this row"
                  >
                    <DeleteIcon />
                    Delete
                  </ConfirmationButton>
                </TableCell>
              ) : (
                <TableCell></TableCell>
              )}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
